const sendCredentialsForLoginOrRegister = require("./sendCredentialsForLoginOrRegister");
const sendVerifierForLoginOrRegister = require("./sendVerifierForLoginOrRegister");
const setupRequest = require("./setupRequest");
const handleForm = require("./handleForm");

module.exports = {
  sendCredentialsForLoginOrRegister,
  sendVerifierForLoginOrRegister,
  setupRequest,
  handleForm,
};
